/**
 * Agent Module
 */
import helper from 'util/helpers';
import $http from '@/http';
import { store } from '@/store/store';
import logReport from '@/util/logReport';

const getDefaultState = () => {
  return {
    agentId: null,
    ticketAgentId: null, // TODO (MultiBrand) : ticketAgentId -> agentId 변경으로 삭제 필요
    talkAgentWorkingStatus: null,
    callAgentWorkingStatus: null,
    authorities: null,
    email: null,
    loginId: null,
    name: null,
    currentBrandId: null,
    currentBrandName: null,
    currentTicketBrandId: null,
    currentTicketBrandName: null,
    customTemplates: [],
    updatedCustomerInfos: [],
    treeNodeSelectedItem: {},
    currentParentBrandId: null,
    moduleChannelId: null,
    workingStatusList: [],
    isProcessingPatchWorkingStatus: true,
    categoryIdList: [],
    notepadOn: false
  };
};
const state = getDefaultState();

const getters = {
  agentId: (state) => {
    return state.agentId;
  },
  email: (state) => {
    return state.email;
  },
  name: (state) => {
    return state.name;
  },
  ticketAgentId: (state) => {
    return state.ticketAgentId;
  },
  loginId: (state) => {
    return state.loginId;
  },
  customTemplates: (state) => {
    return state.customTemplates;
  },
  talkAgentWorkingStatus: (state) => {
    return state.talkAgentWorkingStatus;
  },
  callAgentWorkingStatus: (state) => {
    return state.callAgentWorkingStatus;
  },
  currentBrandId: (state) => {
    return state.currentBrandId;
  },
  currentBrandName: (state) => {
    return state.currentBrandName;
  },
  currentTicketBrandId: (state) => {
    return state.currentTicketBrandId;
  },
  currentTicketBrandName: (state) => {
    return state.currentTicketBrandName;
  },
  updatedCustomerInfos: (state) => {
    return state.updatedCustomerInfos;
  },
  findCustomerName: (state) => (room) => {
    let customerInfos = state.updatedCustomerInfos.find(
      (customerInfo) => room.customer.userKey === customerInfo.customer.userKey && room.brand.id === customerInfo.brand.id
    );
    return helper.longTextLengthAdjust(
      customerInfos && customerInfos.customer && customerInfos.customer.name
        ? customerInfos.customer.name
        : room.customer.name
        ? room.customer.name
        : room.customer.userKey,
      4
    );
  },
  treeNodeSelectedItem: (state) => {
    return state.treeNodeSelectedItem;
  },
  currentParentBrandId: (state) => {
    return state.currentParentBrandId;
  },
  moduleChannelId: (state) => {
    return state.moduleChannelId;
  },
  getWorkingStatusList: (state) => {
    return state.workingStatusList;
  },
  getCategoryIdList: (state) => {
    return state.categoryIdList;
  },
  getNotepadOn: (state) => {
    return state.notepadOn;
  }
};

const actions = {
  getWorkingStatusList({ state }) {
    if (state.workingStatusList && state.workingStatusList.length === 0) {
      return new Promise((resolve) => {
        $http({
          method: 'GET',
          url: '/api/v1/form/working-status',
          params: {
            workingStatusSearchType: 'HEADER'
          }
        })
          .then(({ data }) => {
            try {
              state.workingStatusList = data;
              resolve(data);
            } catch (e) {
              state.workingStatusList = [];
              console.log(e);
            }
          })
          .catch((err) => {
            console.log(err);
            state.workingStatusList = [];
          });
      });
    }
  },

  async patchWorkingStatus({ state, commit, dispatch }, { type, payload }) {
    const isEtcStatus = (workingStatus) => {
      return !!store.getters.getEtcCallStatusList.find((el) => el.code === workingStatus);
    };
    const isCallAndTalkEtc = isEtcStatus(state.talkAgentWorkingStatus.code) && isEtcStatus(state.callAgentWorkingStatus.code);

    // 톡을 기타로 바꾸려는 상황에서 콜이 '통화중'이거나 '후처리중'이면 변경 취소, 토스트 알럿 띄워주기
    const isCallOrSummary = store.getters.callAgentStatus === '통화중' || store.getters.callAgentStatus === '후처리중';
    if (type === 'TALK' && isCallOrSummary && isEtcStatus(payload.code)) {
      return '콜 상담내용 등록 후 상태 변경이 가능합니다.';
    }

    const data = await dispatch('setWorkingStatus', { key: type === 'TALK' ? 'workingStatus' : 'callWorkingStatus', workingStatus: payload });
    commit('setAgentWorkingStatus', { key: type, workingStatus: type === 'TALK' ? data.workingStatus : data.callWorkingStatus });

    if (type === 'CALL') store.commit('changeCallWorkingStatus', payload.id); // 콜 서버 상태값 변경

    if (isEtcStatus(payload.code)) {
      // 콜 또는 톡에서 '기타' 상태를 선택하면 양쪽 모두 '기타' 상태가 되도록
      await dispatch('setInverseWorkingStatus', { nowType: type, workingStatus: payload });
    } else {
      // 콜과 톡 상태가 '기타'일 때
      // 한쪽 상태를 '상담중' 또는 '상담준비'상태로 변경하려는 경우,
      // 반대쪽 상태를 '상담준비'상태로 변경한다.
      isCallAndTalkEtc &&
        (await dispatch('setInverseWorkingStatus', {
          nowType: type,
          workingStatus: state.workingStatusList.find((el) => el.code === 'PRE_COUNSELING')
        }));
    }

    return false;
  },

  async setInverseWorkingStatus({ commit, dispatch }, { nowType, workingStatus }) {
    const inverseType = nowType === 'TALK' ? 'CALL' : 'TALK';
    commit('setAgentWorkingStatus', { key: inverseType, workingStatus });
    if (inverseType === 'CALL') store.commit('changeCallWorkingStatus', workingStatus.id); // 콜 서버 상태값 변경
  },

  setWorkingStatus({ state, commit }, { key, workingStatus }) {
    if (state.isProcessingPatchWorkingStatus) {
      return new Promise((resolve, reject) => {
        commit('changeIsProcessingPatchWorkingStatus', false);
        if (key === 'callWorkingStatus') {
          logReport.write(`[API] REQ /api/v2/agents : {${key} : ${workingStatus.code}}`);
        }

        $http({
          method: 'PATCH',
          url: '/api/v2/agents',
          data: {
            [key]: workingStatus.code
          }
        })
          .then(({ data }) => {
            commit('changeIsProcessingPatchWorkingStatus', true);
            if (key === 'callWorkingStatus') {
              logReport.write(`[API] RES /api/v2/agents : {${JSON.stringify(data)}`);
            }

            resolve(data);
          })
          .catch((e) => {
            reject(new Error(e.message));
          });
      });
    }
  }
};

const mutations = {
  setAgentState(state, parsedInfo) {
    this.$token = parsedInfo || null;
    state.agentId = parsedInfo.agentId;
    state.loginId = parsedInfo.loginId;
    state.name = parsedInfo.name;
    state.email = parsedInfo.email;
    state.authorities = parsedInfo.authorities;
    state.ticketAgentId = parsedInfo.ticketAgentId;
  },
  setAgentWorkingStatus(state, { key, workingStatus }) {
    state[key === 'TALK' ? 'talkAgentWorkingStatus' : 'callAgentWorkingStatus'] = workingStatus;
  },
  setCustomTemplates(state, payload) {
    if (Array.isArray(payload)) {
      state.customTemplates = payload;
    } else if (typeof payload === 'object') {
      const oneKey = state.customTemplates.find((template) => template.templateId === payload.templateId);
      if (!oneKey) {
        state.customTemplates.push(payload);
        return;
      }
      oneKey.message = payload.message;
    }
  },
  changeCurrentBrandId(state, brandId) {
    state.currentBrandId = brandId;
  },
  changeCurrentBrandName(state, brandName) {
    state.currentBrandName = brandName;
  },
  changeTicketBrandId(state, brandId) {
    state.currentTicketBrandId = brandId;
  },
  changeTicketBrandName(state, brandName) {
    state.currentTicketBrandName = brandName;
  },
  changeName(state, name) {
    state.name = name;
  },
  pushUpdateCustomerInfo(state, payload) {
    let index = state.updatedCustomerInfos.findIndex(
      (customerInfo) => payload.customer.userKey === customerInfo.customer.userKey && payload.brand.id === customerInfo.brand.id
    );
    if (index === -1) {
      state.updatedCustomerInfos.push(payload);
    } else {
      state.updatedCustomerInfos[index] = payload;
      state.updatedCustomerInfos.push();
    }
  },
  CLEAR_AGENT(state) {
    Object.assign(state, getDefaultState());
  },
  changeTreeNodeSelectedItem(state, payload) {
    state.treeNodeSelectedItem = payload;
  },
  changeModuleChannelId(state, brandId) {
    state.moduleChannelId = brandId;
  },
  changeIsProcessingPatchWorkingStatus(stats, isProcessingPatchWorkingStatus) {
    state.isProcessingPatchWorkingStatus = isProcessingPatchWorkingStatus;
  },
  changeCategoryIdList(state, payload) {
    state.categoryIdList = payload;
  },
  changeNotepadOn(state, payload) {
    state.notepadOn = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/agent/index.js